// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2DnbD","header":"Messages_header__1U34V"};